module.exports = __webpack_public_path__ + "static/media/05.c4fdbc7d.mp3";